var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.disabled)?_c('div',{staticClass:"cly-vue-remover",on:{"click":_vm.remove}},[_vm._t("default",function(){return [_c('i',{staticClass:"el-icon-delete"})]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }